import React, {useState, useEffect} from 'react';
import './FeedPost.css'
import PostFeel from './PostFeel';
import FeedPosts from './FeedPosts';
import db from './firebase';


function FeedPost({profilePic, username, userId, posttype}) {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        db.collection('posts').orderBy('timestamp', 'desc').onSnapshot((snapshot) => 
            setPosts(snapshot.docs.map((doc) => ({ id: doc.id, 
                data: doc.data() })))
        ); 
    }, []);

    return (
        <div className="feedPost">
            <PostFeel 
            username={username}
            userId = {userId}
            profilePic = {profilePic}
            />
            {
                posts.map((post) => (
                    
                    <FeedPosts 
                        userId = {userId}
                        key = {post.id}
                        postId = {post.id}
                        profile= {post.data.profilePic}
                        message = {post.data.message}
                        timestamp = {post.data.timestamp}
                        name = {post.data.username}
                        image = {post.data.image}
                        likeObj = {post.data.like}
                        like = {post.data.like[userId]}
                        likeScore = {post.data.likeScore}
                    />
                ))
            }
                    
            <p className="footer__text"> Privacy . Terms . Memory Site &copy; {new Date().getFullYear()} : Coded by YMH</p>
        </div>
    )
}

export default FeedPost
